import angular from 'angular';
import component from './alert-templates.component';
import templateDetail from './template-detail';

const alertTemplatesModule = angular
    .module('dt.components.organization-alert-config.alert-templates', [
        templateDetail
    ])
    .component('alertTemplates', component);

export default alertTemplatesModule.name; 